// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 167 ? "80289b8c" : chunkId) + "." + {"167":"05d0357c9343f14b","171":"1764367a5ba5250a","753":"e3bea01958f3ea2c"}[chunkId] + ".js";
};